import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Key } from 'lucide-react';

const Integrations = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">API Keys & Integrations</h1>
        <p className="text-gray-600 mt-1">Manage third-party API integrations</p>
      </div>

      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <Key className="w-5 h-5 text-purple-600" />
            <CardTitle>Integration Management</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12 text-gray-500">
            <Key className="w-12 h-12 mx-auto mb-4 text-purple-400" />
            <p>Configure API keys and third-party integrations</p>
            <p className="text-sm mt-2">Backend integration pending</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Integrations;